var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{attrs:{"open":_vm.open},on:{"close":function($event){return _vm.$emit('close')}}},[_c('img',{staticClass:"w-full h-full object-contain",attrs:{"src":_vm.source,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }